<div class="cbContainer">
    <div class="sgCloseBtn" style="position: absolute; right: 12px; top: 12px;">
        <div class="sgCloseBtnImg" (click)="Cancel()"></div>
    </div>

    <div class="cbHeader">
        <span class="cbHeaderText" cvLocalizedText langSection="Custom_Badges" langKey="Title">Create Your Badge</span>
    </div>

    <div class="cbContentView">
        <div *ngIf="view == Views.Upload" class="cbContentViewUpload">
            <div class="SpotlightManualPreviewBox mt-1" style="border-radius: 50%;">
                <img class="ImagePreviewImg" style="border-radius: 50%;" [ngStyle]="{'background-color': dropAllowed ? '#E9EAEE;' : 'transparent'}" [src]="cropState == cropStates.Cropping ? croppedImage : uploadedImageString" />

                <!-- Image crop container -->
                <div class="SpotlightImageCropContainer cbCropContainer" [hidden]="!(displayImagePicker && imageUploaded)">
                    <div class="FlexRowNoWrap SpotlightImageCropButtonContainer" [hidden]="!(displayImagePicker && imageUploaded)">
                        <div class="SpotlightImgCropDoneBtn" (click)="acceptImageUpload()">
                            <div id="Div1" class="profileAvatarSettingsImgCropDoneText txtOverflow" cvLocalizedText langSection="Profile_Toolbar" langKey="Settings_Picture_Done_Button">Done</div>
                        </div>
                        <div class="SpotlightImgCropCancelBtn" (click)="cancelImageUpload()">
                            <div id="Div2" class="profileAvatarSettingsImgCropCancelText txtOverflow" cvLocalizedText langSection="Profile_Toolbar" langKey="Settings_Picture_Cancel_Button">Cancel</div>
                        </div>
                    </div>
                    <div class="SpotlightImgCrop">
                        <image-cropper class="d-flex flex-wrap align-items-center h-100" 
                            [autoCrop]="true"
                            [roundCropper]="true" 
                            [alignImage]="'center'"
                            [resizeToWidth]="500" 
                            [resizeToHeight]="500" 
                            [cropperMinWidth]="100" 
                            [cropperMinHeight]="100"
                            [maintainAspectRatio]="true" 
                            [imageURL]="uploadedImageString" 
                            [containWithinAspectRatio]="false"
                            (imageCropped)="setCroppedImage($event)"
                            output="base64">
                        </image-cropper>
                    </div>
                </div>
            </div>
            
            <div class="cbUploadInstructionsContainer" [hidden]="!(!imageUploaded && !dropAllowed)">
                <div class="cbUploadInstructions cbuiLine1" cvLocalizedText langSection="Custom_Badges" langKey="Instructions1">Drag and Drop</div>
                <div class="cbUploadInstructions cbuiLine2" cvLocalizedText langSection="Custom_Badges" langKey="Instructions2">file here or</div>
                <div class="cbUploadInstructions cbuiLine3" cvLocalizedText langSection="Custom_Badges" langKey="Instructions3" (click)="uploadImage()">Click to browse</div>
                <div class="cbUploadInstructions cbuiLine4" cvLocalizedText langSection="Custom_Badges" langKey="Instructions4">png files only</div>
                <div class="cbUploadInstructions cbuiLine5" cvLocalizedText langSection="Custom_Badges" langKey="Instructions5" [hidden]="uploadedInvalidFileFormat">For best results, use a transparent background.</div>
                <div class="cbUploadInstructions cbuiLine5" cvLocalizedText langSection="Custom_Badges" langKey="Invalid_Format" [hidden]="!uploadedInvalidFileFormat" style="color: red;">Whoops! Our system isn't setup to handle that file type. Try a png with a transparent background.</div>
            </div>

            <div class="cbUploadHoverState" [hidden]="!dropAllowed"></div>
            <input type="file" title=" " class="slideBackgroundUploader CustomBadgeFileUpload" 
                [accept]="acceptedFileTypes" [ngStyle]="{'pointer-events': (dropAllowed ? 'auto' : 'none'), 'display': (isIEorEdge ? 'none' : 'inline-block')}"
                (change)="handleFileSelect($event)"/>
            <div class="cbFileButtonHider"></div>
        </div>

        <!-- Slider  -->
        <div *ngIf="view == Views.Size">
            <div class="cbSizeBackground">
                <div class="SpotlightManualPreviewBox cbPreviewBox" style="border-radius:50%; background-color: white;">
                    <img class="ImagePreviewImg" style="border-radius: 50%;" [ngStyle]="{'transform': 'scale(' + (scale * 0.01) + ')'}" [src]="uploadedImageString"/>
                </div>
                <div class="FlexRowNoWrap">
                    <div class="decreaseSizeIcon"></div>
                    <div style="flex: 1;">
                        <nouislider [config]="sliderConfig" [ngModel]="scale" (change)="updateScale($event)"></nouislider>
                    </div>
                    <div class="increaseSizeIcon"></div>
                </div>
            </div>
        </div>

        <!-- Color pickers -->
        <div *ngIf="view == Views.Color">
            <div cvLocalizedText langSection="Custom_Badges" langKey="Color_Subtitle" style="font-size: 20px; margin-bottom: 20px; text-align: center;">Pick your colors</div>
            <div class="SpotlightManualPreviewBox cbPreviewBox" style="border-radius: 50%;" [ngStyle]="{'border': '8px solid ' + borderColor, 'background-color': insideColor}">
                <img class="ImagePreviewImg" style="border-radius:50%;" [ngStyle]="{'transform': 'scale(' + (scale * 0.01) + ')'}" [src]="uploadedImageString" />
            </div>
            <div class="FlexRowNoWrap" style="justify-content: space-around;">
                <div>
                    <span cvLocalizedText langSection="Custom_Badges" langKey="Inside_Color" class="px-1" style="font-size: 16px;">Inside Color:</span>
                    <p-colorPicker #foreColor1 [(ngModel)]="insideColor" (onShow)="addInputField(1)" (onHide)="removeInputField(1)"></p-colorPicker>                    
                </div>
                <div>
                    <span cvLocalizedText langSection="Custom_Badges" langKey="Border_Color" style="font-size: 16px;">Border Color:</span>
                    <p-colorPicker #foreColor2 [(ngModel)]="borderColor" (onShow)="addInputField(2)" (onHide)="removeInputField(2)"></p-colorPicker>
                </div>
            </div>
            <div class="cbSavingOverlay" [hidden]="!isSaving">
                <cv-loader [size]="'large'" [overlay]="false"></cv-loader>
            </div>
        </div>
    </div>
    <div [ngClass]="{'cxone-cbfooter': cvConfigurationService.isCxOne}" class="cbFooter">
        <!-- Transition none is to instantly show/hide elements as Angular delays them slightly by default so animations can be used -->
        <ng-container *ngIf="!cvConfigurationService.isCxOne; else cxoneModalBtns">
            <span cvLocalizedText langSection="Common" langKey="Back_Button" class="sgCancelBtn" style="float: left;  cursor: pointer;" *ngIf="view != Views.Upload"  (click)="PrevStep()">Back</span>                
            <span cvLocalizedText langSection="Common" langKey="Save_Button" style="float: right; cursor: pointer; transition: none;" [ngClass]="{'sgStdBtnPrm': !isSaving, 'sgStdBtnDisabled': isSaving}" *ngIf="view == Views.Color" (click)="Save()">Save</span>
            <span cvLocalizedText langSection="Common" langKey="Next_Button" style="float: right; transition: none;" [ngStyle]="{'cursor': nextButtonDisabled ? 'default' : 'pointer'}" *ngIf="view != Views.Color" [ngClass]="{'sgStdBtnDisabled': nextButtonDisabled, 'sgStdBtnPrm': !nextButtonDisabled}" (click)="NextStep()">Next</span>
            <span cvLocalizedText langSection="Common" langKey="Cancel_Button" class="sgCancelBtn" style="float: right; cursor: pointer;" (click)="Cancel()">Cancel</span>
        </ng-container>
        <ng-template #cxoneModalBtns>
            <sol-button variant="basic" size="large" style="float: left" *ngIf="view != Views.Upload"
                (click)="PrevStep()">
                <span cvLocalizedText langSection="Common" langKey="Back_Button">Back</span>
            </sol-button>
            <sol-button variant="primary" size="large" style="float: right"
                [disabled]="isSaving" *ngIf="view == Views.Color" (click)="Save()">
                <span cvLocalizedText langSection="Common" langKey="Save_Button">Save</span>
            </sol-button>
            <sol-button variant="primary" size="large" style="float: right" [disabled]="nextButtonDisabled"
                *ngIf="view != Views.Color" (click)="NextStep()">
                <span cvLocalizedText langSection="Common" langKey="Next_Button">Next</span>
            </sol-button>
            <sol-button variant="basic" size="large" style="float: right; padding-right: 7px;" (click)="Cancel()">
                <span cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</span>
            </sol-button>
        </ng-template>
    </div>
</div>

<div class="customBadgeCreatorOverlay" [hidden]="!showWhen"></div>